export default __webpack_public_path__ + "static/media/award.ecdc7a3f.jpg";